export function isInstanceOf<T extends Constructor<unknown> | ErrorConstructor>(
  expect: T,
  value: unknown
): value is InstanceType<T> {
  return value instanceof expect;
}
